export default "__VITE_ASSET__81088ddb__"